import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import * as breakpoints from '../../data/breakpoints';
import DiagramCreatorThemeSelect from './DiagramCreatorThemeSelect';
import DiagramCreatorPitchSelect from './DiagramCreatorPitchSelect';
import Icon from '../Global/Icons/Icon';


const DiagramCreatorOptions = ({ metadataOptions, changeTheme, changePitch, theme, parentPitch, onParentPitchBackClick, onPitchBackClick }) => {
  let activeOptions = <DiagramCreatorThemeSelect options={metadataOptions.pitchtheme} changeTheme={changeTheme} />;
  if (parentPitch) {
    activeOptions = <DiagramCreatorPitchSelect options={parentPitch.children} theme={theme.class} changePitch={changePitch} onBackClick={onParentPitchBackClick} />;
  } else if (theme) {
    activeOptions = <DiagramCreatorPitchSelect options={metadataOptions.pitchimage} theme={theme.class} changePitch={changePitch} onBackClick={onPitchBackClick} />;
  }

  return (
    <div className="diagram-creator-options">
      <div className="diagram-creator-options-inner">
        <MediaQuery minWidth={breakpoints.MEDIUM}>
          {(matchesDeviceWidth) => {
            if (matchesDeviceWidth) {
              return (
                <MediaQuery query="(orientation: portrait)">
                  {(matchesOrientation) => {
                    if (matchesOrientation) {
                      return (
                        <div className="diagram-creator-device-message rotate-device">
                          <Icon name="device-rotation" size="xl" fill="white" />
                          <p className="h3">For best results, rotate your device to landscape orientation.</p>
                        </div>
                      );
                    }
                    return activeOptions;
                  }}
                </MediaQuery>
              );
            }
            return (
              <div>
                <div className="diagram-creator-device-message not-optimised">
                  <Icon name="device-information" size="xl" fill="white" />
                  <p>The Diagram Creator has not yet been optimised for smaller screens, you may encounter bugs. We recommend creating your diagrams on a larger screen device such as a tablet, laptop or desktop computer.</p>
                </div>

                {activeOptions}
              </div>
            );
          }}
        </MediaQuery>

      </div>
    </div>
  );
};

DiagramCreatorOptions.propTypes = {
  metadataOptions: PropTypes.object,
  changeTheme: PropTypes.func,
  changePitch: PropTypes.func,
  theme: PropTypes.object,
  parentPitch: PropTypes.object,
  onParentPitchBackClick: PropTypes.func.isRequired,
  onPitchBackClick: PropTypes.func.isRequired,
};

export default DiagramCreatorOptions;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/DiagramCreatorOptions.js